import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  AccountTitle,
  InnerContainer,
  LeftCol,
  MainContainer,
  MenuScrollWrap,
  NavSectionLabel,
  RightCol,
  StyledMenu,
} from "./styles";
import ProfileForm from "../ProfileForm";
import ProfileIcon from "@/assets/icons/profile";
import ShippingAddresses from "@/assets/icons/shippingaddress";
import ShippingForm from "../ShippingForm";
import BillingInformationIcon from "@/assets/icons/billingInformationIcon";
import SubscriptionBilling from "../SubscriptionBilling";
import ConnectedStores from "../ConnectedStores";
import MyStoreIcon from "@/assets/icons/myStoreIcon";
import SpendingSummary from "../SpendingSummary";
import MySupport from "../MySupport";

const Profile = () => {
  const [searchParams] = useSearchParams();
  const [current, setCurrent] = useState("spendingSummary");

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab) {
      setCurrent(tab);
    }
  }, [searchParams]);

  const items = [
    {
      label: "Spending Summary",
      key: "spendingSummary",
      icon: <span style={{ fontSize: 16 }}>💰</span>,
      component: <SpendingSummary />,
    },
    {
      label: "Profile",
      key: "profile",
      icon: <ProfileIcon selected={current === "profile"} />,
      component: <ProfileForm />,
    },
    {
      label: "Shipping Addresses",
      key: "shippingAddresses",
      icon: <ShippingAddresses selected={current === "shippingAddresses"} />,
      component: <ShippingForm />,
    },
    {
      label: "Billing Information",
      key: "billingInformation",
      icon: (
        <BillingInformationIcon selected={current === "billingInformation"} />
      ),
      component: <SubscriptionBilling />,
    },
    {
      label: "Connected Stores",
      key: "connectedStores",
      icon: <MyStoreIcon selected={current === "connectedStores"} />,
      component: <ConnectedStores />,
    },
    {
      label: "My Support",
      key: "mySupport",
      icon: <span style={{ fontSize: 16 }}>🎧</span>,
      component: <MySupport />,
    },
  ];

  const onClick = (e) => {
    setCurrent(e.key);
  };

  const selectedItem = items.find((item) => item.key === current);

  return (
    <MainContainer>
      <AccountTitle>My Account</AccountTitle>
      <InnerContainer>
        <LeftCol>
          <NavSectionLabel>Choose a section</NavSectionLabel>
          <MenuScrollWrap>
            <StyledMenu
              onClick={onClick}
              selectedKeys={[current]}
              mode="inline"
              items={items}
            />
          </MenuScrollWrap>
        </LeftCol>
        <RightCol>{selectedItem && selectedItem.component}</RightCol>
      </InnerContainer>
    </MainContainer>
  );
};

export default Profile;
